import { render } from "./PostCardComment.vue?vue&type=template&id=75b10d89&scoped=true"
import script from "./PostCardComment.vue?vue&type=script&lang=js"
export * from "./PostCardComment.vue?vue&type=script&lang=js"

import "./PostCardComment.vue?vue&type=style&index=0&id=75b10d89&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b10d89"]])

export default __exports__